<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  nama: "table-rekap-evaluasi",

  data() {

    return {
      id: this.$route.params.id,
      loadingTable: true,
      dataTableRekap: [],
    }
  }, mounted() {
    this.getDataTableEvaluasiRekap(this.id);
  },
  methods: {
    getDataTableEvaluasiRekap(id) {
      let self = this;
      self.loadingTable = true;

      var config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/penilaian/evaluasi-rekap",
        params: {
          id: id,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token
        }
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          var resData = response.data.data[0];
          self.loadingTable = false;

          self.dataTableRekap = resData;
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error !',
          text: 'Something went wrong ! \n' + error,
          showConfirmButton: true
        })
      });
    },

    syncDataRekap() {
      let self = this;
      Swal.fire({
        title: '<i class="fa fa-spin fa-spiner"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
      })

      var config = {
        method: 'get',
        url: process.env.VUE_APP_BACKEND_URL_VERSION + 'transactions/penilaian/synchron/rekap-evaluasi',
        params: {
          id: self.id,
        },
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.access_token,
        }
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus == 200) {

          Swal.close();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error :)',
            text: 'Something went wrong !',
            showConfirmButton: true,
          });
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error !',
          text: 'Something went wrong !' + error,
          showConfirmButton: true,
        });
      });
    },

    exportEvaluasiRekap() {
      let self = this;

      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: 'Loading . . .',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      var config = {
        method: 'get',
        url: process.env.VUE_APP_BACKEND_URL_VERSION + 'transactions/penilaian/eksportEvaluasi/rekap',
        params: {
          id: self.id,
        },
        crossdomain: true,
        responseType: 'blob',
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
        withCredentials: true,
      };

      axios(config).then((response) => {
        var resStatus = response.status;
        if (resStatus === 200) {
          Swal.close();
          // Download the file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Evaluasi Rekap.xlsx'); // Update filename if needed
          document.body.appendChild(link);
          link.click();
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong !\n' + error,
          showConfirmButton: true
        });
      });
    },
  }
}
</script>

<template>
  <div class="row">
    <div class="row">
      <div class="col-md-12">
        <div class="card-title mt-3">Rekap Evaluasi</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 d-flex justify-content-between align-middle">
        <b-button variant="success" size="sm" @click="syncDataRekap()">
          <i class="fas fa-sync-alt"></i>
          &nbsp;
          <b>Refresh data Rekap</b>
        </b-button>

        <b-button variant="primary" size="sm" @click="exportEvaluasiRekap()">
          <i class="fas fa-file-excel"></i>
          &nbsp;
          <b>Export Evaluasi Rekap</b>
        </b-button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 table-responsive pb-3">
        <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
          <thead class="yellowTheme align-middle">
            <tr>
              <th rowspan="2" class="text-center">NDH</th>
              <th rowspan="2" class="text-center">Nama Peserta</th>
              <th class="text-center">Akademik</th>

              <th class="text-center">Pembelajaran Lapangan</th>
              <th class="text-center">Perencanaan Aksi Perubahan</th>
              <th class="text-center">Implementasi Aksi Perubahan</th>
              <th class="text-center">Sikap Perilaku</th>
              <th class="text-center">Nilai Akhir</th>
              <th rowspan="2" class="text-center">Kualifikasi Kelulusan</th>
              <th rowspan="2" class="text-center">Kelompok</th>
              <th rowspan="2" class="text-center">Peringkat</th>
            </tr>
            <tr>
              <th class="text-center">(15%)</th>
              <th class="text-center">(20%)</th>
              <th class="text-center">(20%)</th>
              <th class="text-center">(30%)</th>
              <th class="text-center">(15%)</th>
              <th class="text-center">(100%)</th>
            </tr>
            <tr v-if="loadingTable.evaluasiRekap">
              <td colspan="30" class="text-center">
                <i class="fas fa-spinner fa-spin"></i>
                &nbsp;
                <span>Loading . . .</span>
              </td>
            </tr>
            <tr v-else-if="dataTableRekap == ''">
              <td colspan="30" class="text-center">
                <span>-- Data kosong --</span>
              </td>
            </tr>
            <tr v-else v-for="(row, index) in dataTableRekap" :key="index" class="align-top">
              <td class="text-center">{{ index + 1 }}</td>
              <td>{{ row.user.name }}</td>
              <td class="text-center"><span class="numberHover" :title="row.user.name">{{ row.average_akademik }}</span></td>
              <td class="text-center"><span class="numberHover" :title="row.user.name">{{ row.average_stula }}</span></td>
              <td class="text-center"><span class="numberHover" :title="row.user.name">{{ row.average_perencanaan }}</span></td>
              <td class="text-center"><span class="numberHover" :title="row.user.name">{{ row.average_implementasi }}</span></td>
              <td class="text-center"><span class="numberHover" :title="row.user.name">{{ row.average_sikap_perilaku }}</span></td>
              <td class="text-center"><span class="numberHover" :title="row.user.name">{{ row.nilai_akhir }}</span></td>
              <td class="text-center">
                <span v-if="row.kualifikasi_kelulusan == 'Sangat Memuaskan'" class="badge badge-pill bg-badge-green font-size-11">
                  {{ row.kualifikasi_kelulusan }}
                </span>
                <span v-else-if="row.kualifikasi_kelulusan == 'Memuaskan'" class="badge badge-pill bg-badge-blue font-size-11">
                  {{ row.kualifikasi_kelulusan }}
                </span>
                <span v-else-if="row.kualifikasi_kelulusan == 'Cukup Memuaskan'" class="badge badge-pill bg-badge-blue-sky font-size-11">
                  {{ row.kualifikasi_kelulusan }}
                </span>
                <span v-else-if="row.kualifikasi_kelulusan == 'Kurang Memuaskan'" class="badge badge-pill bg-badge-yellow font-size-11">
                  {{ row.kualifikasi_kelulusan }}
                </span>
                <span v-else-if="row.kualifikasi_kelulusan == 'Tidak Memuaskan'" class="badge badge-pill bg-badge-red font-size-11">
                  {{ row.kualifikasi_kelulusan }}
                </span>
              </td>
              <td class="text-center"><span class="numberHover">1</span></td>
              <td class="text-center"><span class="numberHover">2</span></td>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>